/**
 * @fileoverview DELETE handler for the "/companies/:company_id/verified_domains/:id" endpoint
 */
import fetch from "@lib/fetch";

import {
  createMutationFetcherFunctionWithShadowError,
  reactQueryMutationAdapter,
} from "../reactQueryFetcherAdapters";
import { deleteCompaniesCompanyIdVerifiedDomainsIdCacheKeys } from "./constants";
import type { DeleteCompaniesCompanyIdVerifiedDomainsIdProps } from "./types";

export const deleteCompaniesCompanyIdVerifiedDomainsId = reactQueryMutationAdapter(
  deleteCompaniesCompanyIdVerifiedDomainsIdCacheKeys,
  createMutationFetcherFunctionWithShadowError()(
    (props: DeleteCompaniesCompanyIdVerifiedDomainsIdProps): Promise<void> => {
      return fetch(
        `/companies/${props.companyId}/verified_domains/${props.id}`,
        "DELETE",
        { type: props.type },
        undefined,
        { propagateFetchRequestError: false }
      );
    }
  )
);
